<template>
  <div
    :class="{ 'pegas-Wrapper-disabled': disabled }"
    class="pegas-Wrapper"
    data-auto-testid="form-grade-and-status"
  >
    <FormGradeAndStatusTopBlock>
      <template #grade-block>
        <div class="oboard-truncated-text">
          <AppTag
            :content="elementStatus"
            :content-background="resolvedElementStatusColor.background"
            :content-color="resolvedElementStatusColor.text"
            class="pegas-Status"
          />
        </div>
        <OkrGradeValue :grade="grade" />
      </template>
      <template #indicator-panel>
        <IndicatorPanel
          :background-color="resolvedElementStatusColor.background"
          :color="resolvedElementStatusColor.text"
          :indicator-width="grade"
          rounded-bar
          style="--height: 6px; --border-radius: 6px"
        />
      </template>
    </FormGradeAndStatusTopBlock>
    <FormGradeAndStatusBottomBlock
      v-if="!isAutoMode"
      :disabled="disabled"
      :element-target-periods="elementTargetPeriods"
      :form-model="formModel"
      @save-grade="emit('save-grade', $event)"
    />
  </div>
</template>

<script setup>
import { computed, toValue } from 'vue'

import { DEFAULT_MILESTONES_SETTINGS, GRADE_MODES } from '@/utils/okr-element-values'
import { OKR_ELEMENT_KEYS } from '@/utils/view-row-actions'

import FormGradeAndStatusBottomBlock from '@/components/form/FormGradeAndStatusBottomBlock'
import FormGradeAndStatusTopBlock from '@/components/form/FormGradeAndStatusTopBlock'
import OkrGradeValue from '@/components/form/OkrGradeValue'
import AppTag from '@/components/ui/AppTag/AppTag'
import IndicatorPanel from '@/components/ui/IndicatorPanel/IndicatorPanel'

defineOptions({
  name: 'PlatformElementFormGradeAndStatus'
})

const emit = defineEmits({ 'save-grade': null })

const props = defineProps({
  grade: {
    type: Number,
    required: true
  },

  elementStatus: {
    type: String,
    default: 'To Do',
    required: true
  },

  elementStatusColor: {
    type: Object,
    default: () => ({
      background: '',
      text: ''
    }),
    required: true
  },

  formModel: {
    type: Object,
    required: true
  },

  disabled: {
    type: Boolean
  },

  elementTargetPeriods: {
    type: Array,
    default: () => DEFAULT_MILESTONES_SETTINGS[OKR_ELEMENT_KEYS.ELEMENT_TARGET_PERIODS]
  }
})

const resolvedElementStatusColor = computed(() => {
  return {
    background: props.elementStatusColor?.background || '#dfe1e6',
    text: props.elementStatusColor?.text || '#42526e'
  }
})

const isAutoMode = computed(() => {
  return toValue(props.formModel).gradeMode === GRADE_MODES.AUTO
})
</script>

<style lang="scss" scoped>
.pegas-Wrapper {
  display: grid;
  overflow: hidden;
  // gap: 24px;
  border: 2px solid $grey-3-next;
  border-radius: $border-radius-md-next;

  &-disabled {
    background: $grey-3-next;
  }
}

.pegas-Status {
  line-height: 24px;
  // padding: 4px 10px;
  padding: 2px 8px;
  margin-bottom: 8px;
}
</style>
